export default function isLocal(path) {
  return /^(https?:)?\/\/localhost($|[/:])/.test(path)
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/isLocal.js